import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
  } from "@angular/core";
  import {
    AggregateService,
    DataStateChangeEventArgs,
    GridComponent,
  } from "@syncfusion/ej2-angular-grids";
  import { IMyDpOptions } from "mydatepicker";
  import { Observable, Subject } from "rxjs";
  import { takeUntil } from "rxjs/operators";
  import { GlobalComponent } from "src/app/global/global.component";
  import { ColumnChangeBO } from "../../eligibility270/eligibility270.model";
  import { columnWidth, WhereCondition } from "../../icd10/icd10.model";
  import { ToastrService } from "ngx-toastr";
  import { FormControl, FormGroup, Validators } from "@angular/forms";
  import { DateService } from "src/app/date.service";
  import { DatePipe } from "@angular/common";
  import {
    AdminTimeEventEmitterBo,
    DeleteAdminTimeBO,
    GetAdminTimeBO,
    SaveAdminTimeNonBillable,
  } from "../admin-time.modal";
  import { CommonApiService } from "src/app/commonapiservice";
  
  @Component({
    selector: "app-admin-time-list",
    templateUrl: "./admin-time-list.component.html",
    styleUrls: ["./admin-time-list.component.scss"],
    providers: [AggregateService],
  })
  export class AdminTimeListComponent implements OnInit {
    private onDestroy$: Subject<void> = new Subject<void>();
    ATList: any = [];
    AdminTimeId: any;
    resetPass: FormGroup;
    initialPage: object;
    passerror: boolean = false;
    conditionlist: WhereCondition[] = [];
    filterOptions: object;
    isDataAvailableToPrint: boolean = false;
    columnchange: ColumnChangeBO = new ColumnChangeBO();
    id:string = "00000000-0000-0000-0000-000000000000";
    deleteList: DeleteAdminTimeBO = new DeleteAdminTimeBO();
    arraycol: any = [];
    public height = "220px";
    ATNotes: string = "";
    ColumnArray: columnWidth[];
    ValidationDate: any;
    @Input() ListATInputProperty: AdminTimeEventEmitterBo =
      new AdminTimeEventEmitterBo();
    updateAdminTimeNonBillable: SaveAdminTimeNonBillable =
      new SaveAdminTimeNonBillable();
    @Output() ListOutputzat = new EventEmitter<AdminTimeEventEmitterBo>();
    @ViewChild("gridAT") public gridAT: GridComponent;
    locationLid:string ='00000000-0000-0000-0000-000000000000';
    getFilterBo: GetAdminTimeBO = new GetAdminTimeBO();
    ListEmployeeId: string = "00000000-0000-0000-0000-000000000000";
    ListStartDate: any;
    ListEndDate: any;
    showATpage: boolean = false;
    EmployeeDropDown: any = [];
    datetimeformatoption: object;
    public formatOptions: object;
    public data: Observable<DataStateChangeEventArgs>;
    public myDatePickerOptions: IMyDpOptions = {
      dateFormat: "mm/dd/yyyy",
      disableSince: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate() + 1,
      },
      showClearDateBtn: true,
      editableDateField: true,
    };
    totalhoursSummaryMinutes: any;
    EditEntryTypeList:any=[];
    constructor(
      public CommonAPI: CommonApiService,
      public datepipe: DatePipe,
      private cdr: ChangeDetectorRef,
      public dateservice: DateService,
      public toasterService: ToastrService,
      public global: GlobalComponent
    ) {
      this.global.agencyList();
      this.data = CommonAPI;
      this.resetPass = new FormGroup({
        Password: new FormControl("", [Validators.required]),
      });
    }
    ngAfterContentChecked() {
      this.cdr.detectChanges();
    }
    ngOnInit(): void {
  
      if (
        this.global.globalAgencyId == null ||
        this.global.globalAgencyId == "" ||
        this.global.globalAgencyId == undefined ||
        this.global.globalAgencyId == 0
      ) {
        return;
      }
      this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
  
      this.datetimeformatoption = {
        type: "date",
        format: "MM/dd/yyyy h:mm:ss a",
      };
      this.filterOptions = { type: "Menu" };
      if (
        this.global.globalLocationId == null ||
        this.global.globalLocationId == undefined ||
        this.global.globalLocationId == ""
      ) {
        this.locationLid = '00000000-0000-0000-0000-000000000000';
      } else {
        this.locationLid = this.global.globalLocationId;
      }
      this.ListStartDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
      this.ListEndDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
      let Page = 10;
      if (this.ListATInputProperty.isClose == false) {
        this.initialPage = {
          currentPage: 1,
          pageSizes: ["10", "15", "20", "50", "100", "250"],
          pageSize: Page,
        };
      } else {
        this.getFilterBo = this.ListATInputProperty.getListDetails;
        this.initialPage = {
          currentPage: this.ListATInputProperty.getListDetails.currentpage,
          pageSizes: ["10", "15", "20", "50", "100", "250"],
          pageSize: Page,
        };
      }
      this.getFilterBo.pageitems = Page;
      this.getEmployeeDropDown();
      this.getValidationDate();
      this.ApplyFilter();
      this.getEntrytypelov();
    }
  
    //......................................getEmployeeDropDown.........................................................
    getEmployeeDropDown() {
      let url = "api/Employee/EmployeeDropDown?";
      let params = new URLSearchParams();
      params.append("LocationId", this.locationLid);
      this.CommonAPI
        .GetFunctionwithResponseTypeJson(params, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((data: any) => {
          this.EmployeeDropDown = data;
          this.ListATInputProperty.EmployeeDropDown = this.EmployeeDropDown
        });
    }
    //...................................... ApplyFilter......................................
    ApplyFilter() {
      if (
        this.ListStartDate != null &&
        this.ListStartDate != undefined &&
        this.ListStartDate != ""
      ) {
        this.getFilterBo.startDate = this.global.getDateTimeString(
          this.ListStartDate
        );
      } else {
        this.getFilterBo.startDate = null;
        this.ListStartDate = null;
      }
      if (
        this.ListEndDate != null &&
        this.ListEndDate != undefined &&
        this.ListEndDate != ""
      ) {
        this.getFilterBo.endDate = this.global.getDateTimeString(
          this.ListEndDate
        );
      } else {
        this.getFilterBo.endDate = null;
        this.ListEndDate = null;
      }
      if (
        this.ListEmployeeId != null &&
        this.ListEmployeeId != undefined &&
        this.ListEmployeeId != ""
      ) {
        this.getFilterBo.employeeId = this.ListEmployeeId;
      } else {
        this.getFilterBo.employeeId =  "00000000-0000-0000-0000-000000000000";
        this.ListEmployeeId = null;
      }
      this.getAtFilter();
    }
    //...................................... Refresh......................................
    Refresh() {
      this.getFilterBo = new GetAdminTimeBO();
      this.ListEmployeeId = null;
      this.ListStartDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
      this.ListEndDate =
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear();
      this.getValidationDate();
      let Page = 10;
      this.getFilterBo.pageitems = Page;
      this.updateAdminTimeNonBillable = new SaveAdminTimeNonBillable();
      this.ApplyFilter();
    }
    //................................................... dataStateChange.................................................
    public dataStateChange(state): void {
      let type: String = state.action.requestType.toString();
      this.getFilterBo.currentpage = this.gridAT.pagerModule.pagerObj.currentPage;
      this.getFilterBo.pageitems = this.gridAT.pagerModule.pagerObj.pageSize;
      if (state.action.requestType != "filterchoicerequest") {
        if ((state.sorted || []).length) {
          this.getFilterBo.orderColumn = state.sorted[0].name;
          this.getFilterBo.orderType =
            state.sorted[0].direction === "descending" ? "desc" : "asc";
        }
      }
      if (type == "filtering" && state.action.action != "clearFilter") {
        if (this.getFilterBo.type == "date") {
          this.getFilterBo.value = new Date(
            new Date(
              state.action.currentFilterObject.value
            ).toLocaleDateString() +
            " " +
            "00:00:00" +
            " " +
            "GMT"
          )
            .toISOString()
            .replace("Z", "");
        } else {
          this.getFilterBo.value = state.action.currentFilterObject.value;
        }
        this.getFilterBo.field = state.action.currentFilterObject.field;
        this.getFilterBo.operator = state.action.currentFilterObject.operator;
  
        if (state.action.currentFilterObject.field == "totalhours") {
          this.getFilterBo.value = this.getFilterBo.value.toString();
        }
      }
      if (
        state.action.requestType == "filtering" &&
        state.action.action == "clearFilter"
      ) {
        this.getFilterBo.field = "employeeName";
        this.getFilterBo.matchCase = false;
        this.getFilterBo.operator = "startswith";
        this.getFilterBo.value = "";
        this.getFilterBo.type = "string";
      }
      if (state.action.requestType != "refresh") {
        this.ApplyFilter();
      }
      if (
        state.action.requestType == "paging" &&
        state.action.name == "actionBegin"
      ) {
        if (this.arraycol.length != 0) {
          if (this.arraycol[0].Admin_Time.Pagesize != state.take) {
            this.arraycol[0].Admin_Time.Pagesize = state.take;
            // this.SaveColumnwidth();
          }
        }
      }
    }
    //...................................... onActionComplete......................................
    public onActionComplete(args) {
      if (args.requestType == "columnstate") {
        let hidearr = [];
        let showarr = [];
        this.gridAT.columns.forEach((element) => {
          if (
            element.visible == false &&
            element.headerText != "Actions" &&
            element.headerText != ""
          ) {
            hidearr.push(element.headerText);
          }
          if (
            element.visible == true &&
            element.headerText != "Actions" &&
            element.headerText != ""
          ) {
            showarr.push(element.headerText);
          }
        });
        var count = 0;
        var count1 = 0;
        if (args.columns.length > 0) {
          if (this.arraycol.length > 0) {
            this.arraycol[0].Admin_Time.ShowColumns.forEach((old) => {
              showarr.forEach((element) => {
                if (old == element) {
                  count1 = count1 + 1;
                }
              });
            });
            this.arraycol[0].Admin_Time.HideColumns.forEach((old) => {
              hidearr.forEach((element) => {
                if (old == element) {
                  count = count + 1;
                }
              });
            });
            if (
              this.arraycol[0].Admin_Time.ShowColumns.length != count1 ||
              this.arraycol[0].Admin_Time.HideColumns.length != count
            ) {
              this.arraycol[0].Admin_Time.ShowColumns = showarr;
              this.arraycol[0].Admin_Time.HideColumns = hidearr;
            //   this.SaveColumnwidth();
            }
          }
        }
      }
      this.conditionlist = [];
      if (args.requestType == "filterafteropen") {
        this.getFilterBo.type = args.columnType;
      }
    }
    //...................................... getAtFilter......................................
    getAtFilter() {
      let url = "api/AdminTimeNonBillable/GetAdminTimeDetails"
      let responseData =
      {
        result: "result",
        count: "count",
        sumOfTotalHours: "sumOfTotalHours"
      }
      this.CommonAPI.outputValues(url, this.getFilterBo, responseData,"");
      this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.ATList = data.result;
        if (data != null && data != undefined) {
          // this.getColumnwidth();
        }
        if (data != null && data.result.length > 0) {
          this.isDataAvailableToPrint = true;
        } else {
          this.isDataAvailableToPrint = false;
        }
        if (data != null && data != undefined && data.result.length > 15) {
          this.gridAT.height = "500";
        } else {
          // this.gridAT.height = "auto";
        }
  
        let hoursMinutes = data.sumOfTotalHours.toString().split(".");
        if (hoursMinutes.length == 1) {
          this.totalhoursSummaryMinutes =
            hoursMinutes[0] + " hr " + "0 Min";
  
        } else {
          let minutes = 0 + "." + hoursMinutes[hoursMinutes.length - 1];
          this.totalhoursSummaryMinutes =
            hoursMinutes[0] +
            " hr " +
            (parseFloat(minutes) * 60).toString().split(".")[0] +
            "Min";
  
  
        }
      });
  
    }
    //...................................... onResize......................................
    onResize(args) {
      if (this.ColumnArray != undefined && this.ColumnArray != null) {
        const column = this.gridAT.getColumnByField(args.column.field);
        column.width = args.column.width;
        this.ColumnArray.forEach((element) => {
          if (element.column == column.headerText) {
            element.width = parseInt(column.width.toString());
          }
        });
        // this.SaveColumnwidth();
      }
    }
    //...................................... getColumnwidth......................................
    getColumnwidth() {
      this.arraycol = JSON.parse(this.global.globalColumn.column);
      this.ColumnArray = this.arraycol[0].Admin_Time.Columns;
      let showcol = this.arraycol[0].Admin_Time.ShowColumns;
      if (
        this.global.globalColumn.userid != null &&
        this.global.globalColumn.agencyId != null
      ) {
        this.id = this.global.globalColumn.id;
      }
      let values = this.arraycol[0].Admin_Time.HideColumns;
      this.gridAT.hideColumns(values);
      this.gridAT.pageSettings.pageSize = this.arraycol[0].Admin_Time.Pagesize;
      this.ColumnArray.forEach((element) => {
        // Employee
        if (element.column == "Employee") {
          const column1 = this.gridAT.getColumnByField("employeeName");
          column1.headerText = element.column;
          column1.width = element.width;
          this.gridAT.refreshHeader();
        }
        // In
        if (element.column == "In Time") {
          const column3 = this.gridAT.getColumnByField("inTime");
          column3.headerText = element.column;
          column3.width = element.width;
          this.gridAT.refreshHeader();
        }
        // Out
        if (element.column == "Out Time") {
          const column3 = this.gridAT.getColumnByField("outTime");
          column3.headerText = element.column;
          column3.width = element.width;
          this.gridAT.refreshHeader();
        }
        // Date
        if (element.column == "Date") {
          const column3 = this.gridAT.getColumnByField("date");
          column3.headerText = element.column;
          column3.width = element.width;
          this.gridAT.refreshHeader();
        }
        // Total Hours
        if (element.column == "Total Hours") {
          const column3 = this.gridAT.getColumnByField("totalhours");
          column3.headerText = element.column;
          column3.width = element.width;
          this.gridAT.refreshHeader();
        }
        // EntryType Name
        if (element.column == "Entry Type") {
          const column3 = this.gridAT.getColumnByField("entryTypeName");
          column3.headerText = element.column;
          column3.width = element.width;
          this.gridAT.refreshHeader();
        }
        // Actions/
        else if (element.column == "Actions") {
          const column4 = this.gridAT.getColumnByUid("action");
          column4.headerText = element.column;
          column4.width = element.width;
          this.gridAT.refreshHeader();
        }
      });
    }
  
    //...................................... showColumn......................................
    showColumn() {
      this.gridAT.columnChooserModule.openColumnChooser(200, 50);
    }
    //...................................... EditAt......................................
    EditAT(data) {
      this.updateAdminTimeNonBillable = JSON.parse(JSON.stringify(data));
      (this.updateAdminTimeNonBillable.inTime =
        this.updateAdminTimeNonBillable.inTime != null
          ? this.datepipe.transform(data.inTime, "HH:mm")
          : null),
        (this.updateAdminTimeNonBillable.outTime =
          this.updateAdminTimeNonBillable.outTime != null
            ? this.datepipe.transform(data.outTime, "HH:mm")
            : null),
        (this.updateAdminTimeNonBillable.employeeId = data.employeeId);
      this.updateAdminTimeNonBillable.date =
        data.date != null
          ? this.datepipe.transform(data.date, "MM/dd/yyyy")
          : null;  }
    //...................................... EmitToAtEntry......................................
    EmitToAtEntry() {
      this.ListATInputProperty.isClose = true;
      this.ListATInputProperty.getListDetails = this.getFilterBo;
      this.ListATInputProperty.isCreate = true;
      this.ListOutputzat.emit(this.ListATInputProperty);
    }
    //.....................................ATNewdates.............................................
    ATNewdates(event, type, name) {
      if (type == "inputchanged") {
        if (name == "Start") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.ListStartDate = val1;
          }
        }
        if (name == "End") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.ListEndDate = val1;
          }
        }
        if (name == "updateDate") {
          let val = this.dateservice.inputFeildchange(event);
          if (val != undefined) {
            let val1 = this.dateservice.inputFeildchange(event);
            this.updateAdminTimeNonBillable.date = val1;
          }
        }
      }
      if (type == "datechanged") {
        if (name == "Start") {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let val1 = this.dateservice.Datechange(event);
            this.ListStartDate = val1;
            this.getValidationDate();
            this.clearEndTimeValidation();
          }
        }
        if (name == "End") {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let val1 = this.dateservice.Datechange(event);
            this.ListEndDate = val1;
            this.clearEndTimeValidation();
          }
        }
        if (name == "updateDate") {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let val1 = this.dateservice.Datechange(event);
            this.updateAdminTimeNonBillable.date = val1;
          }
        }
      }
    }
    //.....................................getValidationDate.............................................
    getValidationDate() {
      var StartDate = new Date(this.ListStartDate);
      let setDate = StartDate.setDate(StartDate.getDate() + 365);
      let getDate = setDate;
      this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
    }
    //.....................................clearEndTimeValidation.............................................
    clearEndTimeValidation() {
      if (
        this.ListStartDate != null &&
        this.ListStartDate != undefined &&
        this.ListStartDate != "" &&
        this.ListEndDate != null &&
        this.ListEndDate != undefined &&
        this.ListEndDate != ""
      ) {
        let EndDate = this.datepipe.transform(this.ListEndDate, "MM/dd/yyyy");
        if (
          new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()
        ) {
          this.toasterService.error(
            "Date range should not be greater than 1 year"
          );
          this.ListEndDate = null;
          setTimeout(() => {
            this.toasterService.clear();
          }, 3000);
        }
        if (
          this.ListEndDate != null &&
          this.ListEndDate != undefined &&
          this.ListEndDate != ""
        ) {
          if (
            new Date(this.ListStartDate).getTime() >
            new Date(this.ListEndDate).getTime()
          ) {
            this.ListEndDate = null;
            this.toasterService.error("end time should greater than start time");
            setTimeout(() => {
              this.toasterService.clear();
            }, 3000);
            return;
          }
        }
      }
    }
    //.....................................updateAt.............................................
    updateAt() {
      var updateAt: SaveAdminTimeNonBillable = JSON.parse(
        JSON.stringify(this.updateAdminTimeNonBillable)
      );
      updateAt.id = this.updateAdminTimeNonBillable.id;
      updateAt.employeeId = this.updateAdminTimeNonBillable.employeeId ;
      updateAt.totalhours = parseFloat(
        this.updateAdminTimeNonBillable.totalhours.toString()
      );
      updateAt.date = this.global.getDateTimeString(
        this.updateAdminTimeNonBillable.date
      );
      let InTime: any =
        this.updateAdminTimeNonBillable.inTime != null &&
          this.updateAdminTimeNonBillable.inTime != undefined &&
          this.updateAdminTimeNonBillable.inTime != ""
          ? new Date(
            this.updateAdminTimeNonBillable.date +
            " " +
            this.updateAdminTimeNonBillable.inTime
          )
          : this.global.getDateTimeString(new Date()).toString();
      let OutTime: any =
        this.updateAdminTimeNonBillable.outTime != null &&
          this.updateAdminTimeNonBillable.outTime != undefined &&
          this.updateAdminTimeNonBillable.outTime != ""
          ? new Date(
            this.updateAdminTimeNonBillable.date +
            " " +
            this.updateAdminTimeNonBillable.outTime
          )
          : this.global.getDateTimeString(new Date()).toString();
      updateAt.inTime = this.datepipe.transform(InTime, "yyyy-MM-dd'T'HH:mm:ss");
      updateAt.outTime = this.datepipe.transform(
        OutTime,
        "yyyy-MM-dd'T'HH:mm:ss"
      );
      updateAt.entryTypeLid=updateAt.entryTypeLid;
      let url = "api/AdminTimeNonBillable/UpdateAdminTime";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(updateAt, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            if (data?.errorList?.length > 0) {
              this.toasterService.error(data.errorList);
              setTimeout(() => {
                this.toasterService.clear();
              }, 8000);
              return;
            }
            this.updateAdminTimeNonBillable = new SaveAdminTimeNonBillable();
            document.getElementById("UpdateModal").click();
            this.toasterService.success("Admin Time updated successfully!"), 8000;
            this.ApplyFilter();
          },
          (err: any) => {
            if (err) {
              this.toasterService.error(err, "Error"), 8000;
            }
          }
        );
    }
    //...................................... passvalid............................................................................
    passvalid(event) {
      let str = event.target.value;
      let res;
      if (
        str.match(/[a-z]/g) &&
        str.match(/[A-Z]/g) &&
        str.match(/[0-9]/g) &&
        str.match(/[^a-zA-Z\d]/g) &&
        str.length >= 8
      ) {
        this.passerror = false;
      } else {
        this.passerror = true;
      }
    }
    //...........................DeleteATT...........................................
    DeleteATT(deleteID) {
      // deleteID.adminTime_id = deleteID.adminTime_id;
      console.log(deleteID);
      let url = "api/AdminTimeNonBillable/DeleteAdminTime";
      this.CommonAPI.DeleteFunctionForPostHttp(deleteID, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            document.getElementById("delete").click();
            this.CancelDelete();
            this.toasterService.success("Admin Time deleted successfully!"), 8000;
            this.ApplyFilter();
          },
          (err: any) => {
            if (err) {
              this.toasterService.error(err, "Error"), 8000;
            }
          }
        );
    }
    //...........................CancelDelete...........................................
    CancelDelete() {
      this.deleteList = new DeleteAdminTimeBO();
      this.passerror = false;
      this.resetPass.reset();
    }
    //...........................shownotesdescription...........................................
    shownotesdescription(list) {
      this.ATNotes = list.notes;
      this.AdminTimeId = list.id;
    }
    //...........................UpdateAdminTimeNotes...........................................
    UpdateAdminTimeNotes() {
      let PayloadNotes = {
        adminTime_id: this.AdminTimeId,
        notes: this.ATNotes,
      };
      let url = "api/AdminTimeNonBillable/UpdateAdminTimeNotes";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(PayloadNotes, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            document.getElementById("OpenNotesModal").click();
            this.toasterService.success("notes saved successfully!"), 8000;
            this.ApplyFilter();
          },
          (err: any) => {
            if (err) {
              this.toasterService.error(err.error, "Error"), 8000;
            }
          }
        );
    }
    //...............................................HoursCalculation............................................................
    HoursCalculation() {
      let InTime =
        this.updateAdminTimeNonBillable.inTime != null &&
          this.updateAdminTimeNonBillable.inTime != undefined &&
          this.updateAdminTimeNonBillable.inTime != ""
          ? new Date(
            this.updateAdminTimeNonBillable.date +
            " " +
            this.updateAdminTimeNonBillable.inTime
          )
          : this.global.getDateTimeString(new Date()).toString();
      let OutTime =
        this.updateAdminTimeNonBillable.outTime != null &&
          this.updateAdminTimeNonBillable.outTime != undefined &&
          this.updateAdminTimeNonBillable.outTime != ""
          ? new Date(
            this.updateAdminTimeNonBillable.date +
            " " +
            this.updateAdminTimeNonBillable.outTime
          )
          : this.global.getDateTimeString(new Date()).toString();
  
      if (
        this.updateAdminTimeNonBillable.inTime != null &&
        this.updateAdminTimeNonBillable.outTime != null &&
        this.updateAdminTimeNonBillable.inTime != "" &&
        this.updateAdminTimeNonBillable.outTime != "" &&
        this.updateAdminTimeNonBillable.inTime != undefined &&
        this.updateAdminTimeNonBillable.outTime != undefined
      ) {
        if (new Date(InTime).getTime() <= new Date(OutTime).getTime()) {
          let inTime = new Date(InTime);
          let outTime = new Date(OutTime);
          let diff = (outTime.getTime() - inTime.getTime()) / 1000;
          let minutesDifference = Math.abs(Math.floor(diff / 60));
          let roundedMinutes = Math.round(minutesDifference / 15) * 15;
          this.updateAdminTimeNonBillable.totalhours = roundedMinutes / 60;
        }
        if (OutTime != null && OutTime != undefined && OutTime != "") {
          if (new Date(InTime).getTime() > new Date(OutTime).getTime()) {
            this.updateAdminTimeNonBillable.outTime = null;
            this.toasterService.error("end time should greater than start time");
            this.updateAdminTimeNonBillable.totalhours = null;
            setTimeout(() => {
              this.toasterService.clear();
            }, 3000);
            return;
          }
        }
      } else {
        this.updateAdminTimeNonBillable.totalhours = null;
      }
    }
    //...........................exportAsExcel...........................................
    async exportAsExcel() {
      let getBO = JSON.parse(JSON.stringify(this.getFilterBo));
      let url = "api/AdminTimeNonBillable/downloadAdminTimeExcel";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(getBO, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((data) => {
          const blob = this.b64toBlob(
            data.fileString,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = data.fileName;
          a.click();
        });
    }
    //...........................b64toBlob...........................................
    b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    };
    //...........................printAspdf...........................................
    printAspdf() {
      let Printdata = this.ATList;
    
      let a = window.open("", "", "height=700, width=700");
    
      a.document.write(`
        <html>
          <head>
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
            <style>
              @media print {
                @page {
                  size: auto; /* Adjusts based on user's choice */
                  margin: 20mm;
                }
                body {
                  font-family: Arial, sans-serif;
                  font-size: 12px;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                  table-layout: fixed; /* Prevents overflow */
                  word-wrap: break-word;
                }
                th, td {
                  border: 1px solid black !important;
                  padding: 8px;
                  text-align: left;
                }
                th {
                  background-color: #f2f2f2;
                }
                .notes-column {
                  white-space: pre-wrap; /* Ensures multi-line wrapping */
                }
              }
            </style>
          </head>
          <body>
            <h2 style="text-align: center;">Attendance Report</h2>
            <table>
              <thead>
                <tr>
                  <th>Employee</th>
                  <th>Date</th>
                  <th>In Time</th>
                  <th>Out Time</th>
                  <th class="notes-column">Notes</th>
                  <th>Total Hours</th>
                  <th>Entry Type</th>
                </tr>
              </thead>
              <tbody>
      `);
    
      Printdata.forEach((element) => {
        a.document.write(`
          <tr>
            <td>${element.employeeName}</td>
            <td>${new Date(element.date).toLocaleDateString()}</td>
            <td>${this.datepipe.transform(element.inTime, "MM/dd/yyyy h:mm:ss a") || ""}</td>
            <td>${this.datepipe.transform(element.outTime, "MM/dd/yyyy h:mm:ss a") || ""}</td>
            <td class="notes-column">${element.notes || ""}</td>
            <td>${element.totalhours || ""}</td>
            <td>${element.entryTypeName || ""}</td>
          </tr>
        `);
      });
    
      a.document.write(`
              </tbody>
            </table>
          </body>
        </html>
      `);
    
      a.document.close();
    
      // Wait for content to load before printing
      setTimeout(() => {
        a.print();
        a.close();
      }, 1000);
    }
    
  
    ////////////////Get EntryType Lov///////////
  getEntrytypelov() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", 'ENTRYTYPE');
    this.CommonAPI.getDropDownList("ENTRYTYPE",params, url, "LovDropDown").then(
      (data:any) => {
        this.EditEntryTypeList = data;
        this.ListATInputProperty.EditEntryTypeList=data;
      },
      (err) => { }
    );
  }
    public ngOnDestroy(): void {
      this.onDestroy$.next();
    }
  }
  